import { SupportFolderSchema } from "@redotech/redo-model/support-folder";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const createSupportFolder = {
  name: "createSupportFolder" as const,
  input: z.object({
    name: z.string().min(1).max(255),
    viewIds: z.array(zExt.objectId()),
    defaultViews: z.array(z.string()),
    isPrivate: z.boolean(),
  }),
  output: SupportFolderSchema,
};
